function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  height: "50",
  width: "100",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("filter", {
  id: "logo_svg__b",
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse",
  height: "33.501",
  width: "32.25",
  x: "44.25",
  y: "8"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: "0",
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_0_2032",
  stdDeviation: "4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__a",
  gradientUnits: "userSpaceOnUse",
  x1: "38.121",
  x2: "76",
  y1: "25.395",
  y2: "25.395"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0",
  stopColor: "#2e0089"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#6417fb"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__c",
  gradientUnits: "userSpaceOnUse",
  x1: "63.879",
  x2: "16.116",
  y1: "25.395",
  y2: "24.954"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0",
  stopColor: "#ff024f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#5700ff"
})), /*#__PURE__*/React.createElement("path", {
  d: "M61.852 11C69.666 11 76 17.445 76 25.395c0 7.95-6.334 14.395-14.148 14.395-7.813 0-23.73-14.395-23.73-14.395S54.038 11 61.851 11z",
  fill: "url(#logo_svg__a)"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#logo_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M52.25 33.502V16l16.25 9.547z",
  fill: "#1b0050"
})), /*#__PURE__*/React.createElement("path", {
  d: "M40.148 11C32.334 11 26 17.445 26 25.395c0 7.95 6.334 14.395 14.148 14.395 7.813 0 23.73-14.395 23.73-14.395S47.962 11 40.149 11z",
  fill: "url(#logo_svg__c)"
})));